(() => {
  'use strict';
  if (window.caPdpPaymentRow20261103) return;
  window.caPdpPaymentRow20261103 = true;

  function initialize(scope = document) {
    scope.querySelectorAll('[data-ca-pdp-payment-row]').forEach(row => {
      if (row.dataset.caInitialized) return;
      const section = row.closest('[data-section-type="product"]');
      const data = row.querySelector('[data-ca-price-variants]');
      const input = row.querySelector('input[name="id"]');
      const terms = row.querySelector('shopify-payment-terms');
      if (!section || !data || !input || !terms) return;
      let variants;
      let nativeMeta;
      try {
        variants = JSON.parse(data.textContent);
        nativeMeta = JSON.parse(terms.getAttribute('shopify-meta') || '{}');
      } catch (error) {
        console.warn('Canadian PDP price row could not initialize.', error);
        return;
      }
      row.dataset.caInitialized = 'true';

      function update(variantId) {
        const variant = variants.find(item => String(item.id) === String(variantId));
        if (!variant) return;
        row.querySelector('[data-ca-price]').textContent = variant.priceLabel;
        row.querySelector('[data-ca-compare]').textContent = variant.compareLabel;
        row.querySelector('[data-ca-save-label]').textContent = variant.savingsLabel;
        row.querySelector('[data-ca-savings]').hidden = variant.compare <= variant.price;
        const nativeVariant = nativeMeta.variants?.find(item => String(item.id) === String(variant.id));
        row.dataset.caOfferAvailable = nativeVariant?.eligible === false ? 'false' : 'true';
        if (input.value !== String(variant.id)) {
          input.value = String(variant.id);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        terms.setAttribute('variant-id', String(variant.id));
      }

      document.addEventListener('variant:change', event => {
        if (row.isConnected && event.detail?.variant) update(event.detail.variant.id);
      });
      section.addEventListener('change', event => {
        if (event.target.name === 'id' && !row.contains(event.target)) update(event.target.value);
      });
      update(input.value);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
